import { render, staticRenderFns } from "./ChamadosRespostas.vue?vue&type=template&id=450929d6&scoped=true&"
import script from "./ChamadosRespostas.vue?vue&type=script&lang=js&"
export * from "./ChamadosRespostas.vue?vue&type=script&lang=js&"
import style0 from "./ChamadosRespostas.vue?vue&type=style&index=0&id=450929d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450929d6",
  null
  
)

export default component.exports